import React, { useState, useEffect } from "react";
import { ethers } from "ethers";
import { FaWallet } from "react-icons/fa";
import "./WalletDisplay.css";

import { useWeb3React } from "@web3-react/core";
import { getErc20Contract } from 'utils/contractHelpers'
import token from 'config/constants/tokens'
import { getFullDisplayBalance } from '../../../../utils/formatBalance'

const PLACEHOLDER_ACCOUNT = ethers.Wallet.createRandom().address;

export default function DisplayWalletBalances(props) {

  const { library, account } = useWeb3React();
  const chainId  = 40;

  const [nativeBalance, setNativeBalance] = useState(0)
  const [mstBalance, setMstBalance] = useState(0);
  const [usdmBalance, setUsdmBalance] = useState(0);

  // get the user wallet native token balance
  useEffect(() => {
    const fetchWalletBalances = async () => {
      if (library && account) {
        try {
          const balance = await library.getBalance(account || PLACEHOLDER_ACCOUNT);
          setNativeBalance(balance);

          const mstContract = getErc20Contract("0x568524DA340579887db50Ecf602Cd1BA8451b243"); // TEMP
          const newMstBalance = await mstContract.balanceOf(account || PLACEHOLDER_ACCOUNT);
          setMstBalance(newMstBalance);

          const usdmContract = getErc20Contract(token.usdm.address[chainId]);
          const newUsdmBalance = await usdmContract.balanceOf(account || PLACEHOLDER_ACCOUNT);
          setUsdmBalance(newUsdmBalance);

        } catch (error) {
          console.error('Error fetching wallet token balances:', error);
        }
      }
    };
    fetchWalletBalances();
    const intervalId = setInterval(fetchWalletBalances, 20000);
    return () => clearInterval(intervalId);
  }, [chainId, account, library]);

    
  const tokenBalances = [
    { header: "TLOS", value: nativeBalance ? nativeBalance.toString() : "0" },
    { header: "MST", value: mstBalance ? mstBalance.toString() : "0" },
    { header: "USDM", value: usdmBalance ? usdmBalance.toString() : "0" }
  ];

  return (
    <>
      <DisplayWalletItems tokenBalances={tokenBalances} />
    </>
  )
}

function WalletItem({ header, value }) {  
    return (
      <div className="wallet-item">
        <div className="header">{header}</div>
        <div className="value">{getFullDisplayBalance(value,18,2).toString()}</div>
      </div>
    );
}

const DisplayWalletItems = ({ tokenBalances }) => {
  return (
    <div className="wallet-container">
      {tokenBalances.map((balance, index) => (
        <WalletItem key={balance.header} header={balance.header} value={balance.value} />
      ))}
    </div>
  );
};

